export default __webpack_public_path__ + "static/media/AnimalFeaturesClaws_05.38209fa4.png";